<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="name"
                    name="name"
                    label="Name"
                    v-validate="'required'"
                    data-vv-as="Name"
                    :error-messages="errors.collect('name')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="description"
                    name="description"
                    label="Description"
                    v-validate="'required'"
                    data-vv-as="Description"
                    :error-messages="errors.collect('description')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-treeview
                    selectable
                    :items="pageList"
                    v-model="selectedPageList"
                    item-children="subPages"
                    item-key="id"
                    item-text="title"
                  ></v-treeview>
                </v-flex>
              </v-layout>
            </v-container>

            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../../store";
import commonservice from "../../../shared/common.service";
export default {
  computed: {
    name: {
      get() {
        return this.$store.state.role.name;
      },
      set(val) {
        this.$store.commit("role/SET_ROLE_DATA", {
          key: "name",
          value: val
        });
      }
    },
    description: {
      get() {
        return this.$store.state.role.description;
      },
      set(val) {
        this.$store.commit("role/SET_ROLE_DATA", {
          key: "description",
          value: val
        });
      }
    },
    pageList: {
      get() {
        return this.$store.state.role.pageList;
      },
      set(val) {
        this.$store.commit("role/SET_ROLE_DATA", {
          key: "pageList",
          value: val
        });
      }
    },
    selectedPageList: {
      get() {
        return this.$store.state.role.selectedPageList;
      },
      set(val) {
        this.$store.commit("role/SET_ROLE_DATA", {
          key: "selectedPageList",
          value: val
        });
      }
    }
  },
  data() {
    return {
      loading: false,
      pageTitle: "Add Role"
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store.dispatch("role/setRole", { id: to.params.id }).then(() => {
        next(p => {
          p.pageTitle = "Edit Role";
        });
      });
    } else {
      store.dispatch("role/initRole").then(() => {
        next(p => {
          p.reset();
        });
      });
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store.dispatch("role/saveRole").then(
            () => {
              commonservice.showSuccessMessage("Role saved successfully");
              this.$router.push("/configuration/role");
              this.loading = false;
            },
            () => {
              this.loading = false;
            }
          );
        }
      });
    },
    reset() {
      this.$store.commit("role/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    }
  }
};
</script>
